import { createAction, props } from '@ngrx/store'
import { TaskAccessResponse, UpdateTaskAccessPayload } from './model'
import { Update } from '@ngrx/entity'
import { CreateTaskAccessPayload } from './model'

export const LoadTaskAccesses = createAction('[TaskAccess] Load TaskAccesses')
export const LoadTaskAccessesComplete = createAction(
  '[TaskAccess] Load TaskAccesses Complete',
  props<{ tasks: TaskAccessResponse[] }>()
)

export const AddTaskAccess = createAction('[TaskAccess] Add TaskAccess', props<{ form: CreateTaskAccessPayload }>())
export const AddTaskAccessComplete = createAction(
  '[TaskAccess] Add TaskAccess Complete',
  props<{ task: TaskAccessResponse }>()
)

export const DeleteTaskAccess = createAction('[TaskAccess] Delete TaskAccess', props<{ id: string }>())
export const DeleteTaskAccessComplete = createAction('[TaskAccess] Delete TaskAccess Complete', props<{ id: string }>())

export const DeleteTaskAccesses = createAction('[TaskAccess] Delete TaskAccesses', props<{ ids: string[] }>())
export const DeleteTaskAccessesComplete = createAction(
  '[TaskAccess] Delete TaskAccesses Complete',
  props<{ ids: string[] }>()
)

export const UpdateTaskAccess = createAction(
  '[TaskAccess] Update TaskAccess',
  props<{ form: UpdateTaskAccessPayload; id: string }>()
)
export const UpdateTaskAccessComplete = createAction(
  '[TaskAccess] Update TaskAccess Complete',
  props<{ update: Update<TaskAccessResponse> }>()
)

export const ArchiveTaskAccesses = createAction('[TaskAccess] Archive TaskAccesses', props<{ ids: string[] }>())
export const ArchiveTaskAccessesComplete = createAction(
  '[TaskAccess] Archive TaskAccesses Complete',
  props<{ updates: Update<TaskAccessResponse>[] }>()
)

export const UnarchiveTaskAccesses = createAction('[TaskAccess] UnArchive TaskAccesses', props<{ ids: string[] }>())
export const UnarchiveTaskAccessesComplete = createAction(
  '[TaskAccess] UnArchive TaskAccesses Complete',
  props<{ updates: Update<TaskAccessResponse>[] }>()
)
